export default __webpack_public_path__ + "static/media/google_icon.e28606a4.svg";